import { Injectable, inject } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as feedAdviceActions from '../store/feed-advice.actions';

@Injectable()
export class FeedAdviceOverviewResolver {
  private store = inject<Store<RootState>>(Store);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  resolve() {
    this.store.dispatch(feedAdviceActions.loadData());
    return of(true);
  }
}
